import React from "react";
import { Card, CardBody, Row, Col, Badge, Table } from "reactstrap";

const DatosFacturacionTab = ({ contact }) => {
  const datosFacturacion = contact?.datos_basicos_facturacion?.[0] || {};

  const formatCurrency = (value) => {
    if (!value) return "N/A";
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP'
    }).format(value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return dateString;
  };

  const getEstadoBadge = (estado, tipo = "servicio") => {
    if (tipo === "servicio") {
      if (estado === "S") return <Badge color="success" size="sm">Activo</Badge>;
      if (estado === "N") return <Badge color="danger" size="sm">Inactivo</Badge>;
    } else {
      if (estado === "1") return <Badge color="success" size="sm">Activo</Badge>;
      if (estado === "0") return <Badge color="danger" size="sm">Inactivo</Badge>;
    }
    return <Badge color="secondary" size="sm">{estado || "N/A"}</Badge>;
  };

  return (
    <div className="datos-facturacion-tab-compact">
      <Row>
        {/* Información Principal */}
        <Col lg={6} className="mb-3">
          <Card className="h-100">
            <CardBody className="p-3">
              <h6 className="text-primary mb-3">
                <i className="fas fa-user me-2"></i>Datos del Suscriptor
              </h6>
              <Table size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{width: '40%'}}>Nombre:</td>
                    <td>{datosFacturacion.nombre_suscriptor || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Dir. Predio:</td>
                    <td>{datosFacturacion.direccion_predio || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Dir. Envío:</td>
                    <td>{datosFacturacion.direccion_envio || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Clase Uso:</td>
                    <td>{datosFacturacion.clase_uso || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Estado Servicio:</td>
                    <td>{getEstadoBadge(datosFacturacion.estado_servicio, "servicio")}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Estado Punto:</td>
                    <td>{getEstadoBadge(datosFacturacion.estado_punto, "punto")}</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>

        {/* Información Financiera */}
        <Col lg={6} className="mb-3">
          <Card className="h-100">
            <CardBody className="p-3">
              <h6 className="text-warning mb-3">
                <i className="fas fa-dollar-sign me-2"></i>Información Financiera
              </h6>
              <Table size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{width: '40%'}}>Cartera:</td>
                    <td>{formatCurrency(datosFacturacion.cartera)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Intereses:</td>
                    <td>{formatCurrency(datosFacturacion.intereses)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Último Pago:</td>
                    <td>{formatCurrency(datosFacturacion.ultimo_pago_valor)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Fecha Pago:</td>
                    <td>{formatDate(datosFacturacion.ultimo_pago_fecha)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Última Facturación:</td>
                    <td>{formatDate(datosFacturacion.ultima_facturacion)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Último Aforo:</td>
                    <td>{formatDate(datosFacturacion.ultimo_aforo)}</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        {/* Información de Unidades */}
        <Col lg={6} className="mb-3">
          <Card className="h-100">
            <CardBody className="p-3">
              <h6 className="text-info mb-3">
                <i className="fas fa-home me-2"></i>Unidades y Volumen
              </h6>
              <Table size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{width: '50%'}}>Unid. Residenciales:</td>
                    <td>{datosFacturacion.unidades_residenciales || "0"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">No Residenciales:</td>
                    <td>{datosFacturacion.no_residenciales || "0"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Residenciales Vacías:</td>
                    <td>{datosFacturacion.residenciales_vacias || "0"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">No Resid. Vacías:</td>
                    <td>{datosFacturacion.no_residenciales_vacias || "0"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Volumen m³:</td>
                    <td>{datosFacturacion.volumen_m3 && !isNaN(parseFloat(datosFacturacion.volumen_m3)) ? parseFloat(datosFacturacion.volumen_m3).toFixed(2) : "0.00"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Madre Comunitaria:</td>
                    <td>{datosFacturacion.madre_comunitaria === "S" ? "Sí" : "No"}</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>

        {/* Información Adicional */}
        <Col lg={6} className="mb-3">
          <Card className="h-100">
            <CardBody className="p-3">
              <h6 className="text-secondary mb-3">
                <i className="fas fa-info-circle me-2"></i>Información Adicional
              </h6>
              <Table size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{width: '40%'}}>Origen Fuente:</td>
                    <td>{datosFacturacion.origen_fuente || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Consecutivo:</td>
                    <td>{datosFacturacion.consecutivo || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Actividades:</td>
                    <td>{datosFacturacion.actividades || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Funcionario Visita:</td>
                    <td>{datosFacturacion.funcionario_visita || "N/A"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Fecha Creación:</td>
                    <td>{formatDate(datosFacturacion.created_date)}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Fecha Modificación:</td>
                    <td>{formatDate(datosFacturacion.modified_date)}</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Observaciones de Visita */}
      {datosFacturacion.observacion_visita && (
        <Row>
          <Col md={12}>
            <Card>
              <CardBody className="p-3">
                <h6 className="text-primary mb-2">
                  <i className="fas fa-comment me-2"></i>Observaciones de Visita
                </h6>
                <p className="mb-0 text-muted">{datosFacturacion.observacion_visita}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DatosFacturacionTab;